export default {
  en: {
    'components.mapping-edit-page.title': 'Edit Mapping',
    'components.mapping-edit-page.no-columns': 'No columns has been found for this mapping.',
    'components.mapping-edit-page.update.success': 'Mapping updated successfully.',
    'components.mapping-edit-page.api-fetch-error': 'Failed to fetch mapping.',
    'components.mapping-edit-page.api-update-error': 'Failed to update the mapping',
  },
};
